
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { groupCsList, delGroupCs } from '@/api/group';
import { UserModule } from '@/store/modules/user';

import DialogSelectedGroups from './components/BranchDialogGroups.vue';

@Component({
  name: 'BranchOrderCustomerGroups',
  components: {
    DialogSelectedGroups
  }
})
export default class extends Vue {
  private searchform:any= {
    servicer: '',
    user: ''
  }
  private listLoading = false;
  private orderList = []
  private listQuery: any = {
    page: 1,
    size: 10,
    total: 0
  };
  private editorData:any={};

  created() {
    this.groupCsList();
  }

  private dialogServicerVisible = false
  private closeSelectedServicer(val: any) {
    this.dialogServicerVisible = val;
  }
  private selectedGroup() {
    this.groupCsList()
  }

  // private searchServicer(val: any) {
  //   this.searchform.servicer = val;
  // }
  // 添加选择服务方
  // private groupServicer:any=[]
  // private nextHandle(val: any) {
  //   this.groupServicer = val;
  //   this.radioSelectedStaff = false;
  //   this.dialogSetStaffVisible = true;
  // }
  // 选择人员
  // private dialogSetStaffVisible = false
  // private radioSelectedStaff = true
  // private closeSetStaffHandle(val: any) {
  //   this.dialogSetStaffVisible = val;
  // }
  // private searchUser(val:any) {
  //   this.searchform.user = val;
  // }
  // 添加群组 选择人员
  // private groupUser:any=[]
  // private selectUser(val:any) {
  // this.groupUser = val;
  // this.dialogServicerVisible = false;
  // this.dialogSetStaffVisible = false;
  // this.$prompt('名称', '群组名称', {
  //   confirmButtonText: '确定',
  //   cancelButtonText: '取消',
  //   inputPlaceholder: '请输入群组名称',
  //   inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{2,20}$/,
  //   inputErrorMessage: '请输入1-20位由数字、字母、中文组成的名称',
  //   inputValue: this.groupName
  // }).then(({ value }: any) => {
  //   if (this.groupId) {
  //     this.addAndEditGroups(value, 2);
  //   } else {
  //     this.addAndEditGroups(value, 1);
  //   }
  // }).catch(() => {

  // });
  // }

  // private addAndEditGroups(name:string, type:number) {
  //   let servicerCompany:any = [];
  //   this.groupServicer.forEach((element:any) => {
  //     let ser:any = {};
  //     ser.servicer_company_id = element.servicer_company_id;
  //     ser.servicer_company_name = element.servicer_company_name;
  //     servicerCompany.push(ser);
  //   });
  //   let userList:any = [];
  //   this.groupUser.forEach((user:any) => {
  //     let u:any = {};
  //     u.user_id = user.id;
  //     u.user_name = user.name;
  //     userList.push(u);
  //   });
  //   let params:any = {};
  //   params.company_id = UserModule.getCompanyId;
  //   params.user_id = UserModule.getUserId;
  //   params.group_type = 13;
  //   params.group_name = name;
  //   params.servicer_company = JSON.stringify(servicerCompany);
  //   params.customer_user = JSON.stringify(userList);
  //   switch (type) {
  //     case 1:
  //       addGroupCs(params).then(res => {
  //         this.showSecussMsg((res as any).msg);
  //         this.groupCsList();
  //       }).catch(err => {
  //         this.showErrorMsg(err.msg);
  //       });
  //       break;
  //     case 2:
  //       params.group_id = this.groupId;
  //       editGroupCs(params).then(res => {
  //         this.showSecussMsg((res as any).msg);
  //         this.groupCsList();
  //       }).catch(err => {
  //         this.showErrorMsg(err.msg);
  //       });
  //       break;
  //   }
  // }
  handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.groupCsList();
  }
  handleSizeChange(val: number) {
    this.listQuery.size = val;
    this.groupCsList();
  }
  private groupCsList() {
    this.listLoading = true;
    const params:any = {
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      user_id: UserModule.getUserId,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    if (this.searchform.servicer) {
      params.servicer_company_id = this.searchform.servicer.servicer_company_id;
    }
    if (this.searchform.user) {
      params.customer_user_id = this.searchform.user.id;
    }
    params.group_type = 13;
    groupCsList(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        this.orderList = res.data.list;
        this.listQuery.total = res.data.count || 0;
      } else {
        this.orderList = [];
        this.listQuery.total = 0;
      }
    }).catch(err => {
      this.orderList = [];
      this.listQuery.total = 0;
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  // 新建群组
  private addGroupsHandle() {
    // this.groupId = '';
    // this.groupName = '';
    // this.groupServicer = [];
    // this.groupUser = [];
    this.editorData = {}
    this.dialogServicerVisible = true;
  }
  // 编辑群组
  private editHandle(row: any) {
    // this.groupId = row.id;
    // this.groupName = row.group_name;
    // this.groupUser = row.customer_list;
    // this.groupServicer = row.servicer_company_list;
    this.editorData = row;
    this.dialogServicerVisible = true;
  }
  private deleteHandle(val: any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let params:any = {
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          user_id: UserModule.getUserId,
          group_id: val.id
        };
        delGroupCs(params).then(res => {
          this.showSecussMsg((res as any).msg);
          _this.groupCsList();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      })
      .catch(() => {});
  }

  private getCustomeName(row:any) {
    let customerNames = '';
    if (row.customer_list) {
      row.customer_list.forEach((element:any) => {
        customerNames = customerNames + element.name + ',';
      });
    }
    return customerNames.substring(0, customerNames.length - 1);
  }
  private getserverName(row:any) {
    let serverNames = '';
    if (row.servicer_company_list) {
      row.servicer_company_list.forEach((aa:any) => {
        serverNames = serverNames + aa.name + ',';
      });
    }
    return serverNames.substring(0, serverNames.length - 1);
  }

  private customHeight = window.innerHeight * 0.4;
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: this.customHeight,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
